@if (layout === "center" && theme() === "v2") {
  <div
    [ngClass]="{ 'bg-container': !hideBackground }"
    class="flex flex-col flex-1 gap-0"
  >
    <div class="flex-1 grid grid-cols-12">
      <div class="mt-2 col-start-3 col-span-8 bg-white rounded-t-md relative">
        <div
          class="absolute inset-0 overflow-hidden overflow-y-auto p-4 flex flex-col gap-2"
        >
          <div class="flex flex-row gap-2 items-center">
            <i class="{{ icon() }} text-xl"></i>

            <div class="flex-1 flex flex-col gap-0">
              <div>
                <span class="text-slate-900 text-xl">{{ title() }}</span>
              </div>

              <div class="flex flex-row items-end">
                <div
                  class="text-xs text-slate-400 text-ellipsis whitespace-nowrap overflow-hidden"
                >
                  <span class="text-xs italic">{{ subTitle() }}</span>
                </div>

                <div
                  class="ml-auto text-xs text-slate-400 text-ellipsis whitespace-nowrap overflow-hidden"
                >
                  <span class="text-xs italic">{{ lastUpdated() }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="h-px bg-slate-200 -mx-4 shrink-0"></div>

          <ng-container [ngTemplateOutlet]="content"></ng-container>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12">
      <div class="col-span-8 col-start-3 flex flex-col">
        <div class="h-px bg-slate-200"></div>

        <div
          class="flex flex-row justify-end gap-2 bg-white rounded-b-md p-4 mb-2"
        >
          @if (pageEditStatusContentTemplateRef?.templateRef) {
            <ng-container
              [ngTemplateOutlet]="pageEditStatusContentTemplateRef!.templateRef"
            ></ng-container>
          }

          @if (!hideCancelButton) {
            <dx-button
              (onClick)="onCancel()"
              [text]="cancelText"
              type="normal"
              stylingMode="text"
              class="mr-4"
            ></dx-button>
          }

          @for (action of actions; track action) {
            <snt-button
              (onClick)="action.onClick.emit()"
              (onClickAsync)="action.onClickAsync.emit($event)"
              [disabled]="isFormPristine && action.enabledOnlyIfDirty"
              [title]="action.title"
              [type]="action.type"
              [icon]="action.icon"
            ></snt-button>
          }

          @if (!hideConfirmButton) {
            <snt-button
              (onClick)="onUpdate()"
              [disabled]="
                confirmDisabled ||
                (!saveAlwaysEnabled && (isFormPristine || updating))
              "
              [loading]="updating"
              [title]="confirmText"
              [icon]="confirmIcon"
              type="primary"
            ></snt-button>
          }

          @if (!disableDropdown && actions.length > 1) {
            <dx-drop-down-button
              [splitButton]="true"
              [useSelectMode]="false"
              [text]="actions?.first?.title || ''"
              [items]="actionItems"
              [width]="250"
              displayExpr="name"
              keyExpr="id"
              type="default"
              (onButtonClick)="onDropdownButtonClick()"
              (onItemClick)="onDropdownButtonItemClick($event)"
            ></dx-drop-down-button>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div
    [ngClass]="{ 'bg-container': !hideBackground }"
    class="flex flex-col flex-1"
  >
    <div
      class="relative flex-1"
      [ngClass]="{
        flex: layout === 'no-grid-full-center'
      }"
    >
      @switch (layout) {
        @case ("default") {
          <div class="absolute inset-0 overflow-hidden overflow-y-auto">
            <div class="grid grid-cols-6">
              <div class="col-span-6 p-2">
                <ng-container [ngTemplateOutlet]="content"></ng-container>
              </div>
            </div>
          </div>
        }
        @case ("center") {
          <div class="absolute inset-0 overflow-hidden overflow-y-auto">
            <div class="grid grid-cols-12">
              <div class="my-2 col-start-3 col-span-8">
                <ng-container [ngTemplateOutlet]="content"></ng-container>
              </div>
            </div>
          </div>
        }
        @case ("no-grid-full-center") {
          <div class="flex-1 grid grid-cols-12">
            <div
              class="flex-1 flex my-2 rounded-md col-start-0 col-span-12 p-2 xl:col-start-3 xl:col-span-8 xl:p-0"
            >
              <ng-container [ngTemplateOutlet]="content"></ng-container>
            </div>
          </div>
        }
      }
    </div>
    <div
      class="grid py-4"
      [ngClass]="{
        'grid-cols-6': layout === 'default',
        'grid-cols-12': layout === 'center' || layout === 'no-grid-full-center'
      }"
    >
      <div
        class="flex flex-row justify-end gap-2"
        [ngClass]="footerActionsColumnClass()"
      >
        @if (pageEditStatusContentTemplateRef?.templateRef) {
          <ng-container
            [ngTemplateOutlet]="pageEditStatusContentTemplateRef.templateRef"
          ></ng-container>
        }

        @if (!hideCancelButton) {
          <dx-button
            (onClick)="onCancel()"
            [text]="cancelText"
            type="normal"
            stylingMode="text"
            class="mr-4"
          ></dx-button>
        }

        @for (action of actions; track action) {
          <snt-button
            (onClick)="action.onClick.emit()"
            (onClickAsync)="action.onClickAsync.emit($event)"
            [disabled]="isFormPristine && action.enabledOnlyIfDirty"
            [title]="action.title"
            [type]="action.type"
            [icon]="action.icon"
          ></snt-button>
        }

        @if (!hideConfirmButton) {
          <snt-button
            (onClick)="onUpdate()"
            [disabled]="
              confirmDisabled ||
              (!saveAlwaysEnabled && (isFormPristine || updating))
            "
            [loading]="updating"
            [title]="confirmText"
            [icon]="confirmIcon"
            type="primary"
          ></snt-button>
        }

        @if (!disableDropdown && actions.length > 1) {
          <dx-drop-down-button
            [splitButton]="true"
            [useSelectMode]="false"
            [text]="actions?.first?.title || ''"
            [items]="actionItems"
            [width]="250"
            displayExpr="name"
            keyExpr="id"
            type="default"
            (onButtonClick)="onDropdownButtonClick()"
            (onItemClick)="onDropdownButtonItemClick($event)"
          ></dx-drop-down-button>
        }
      </div>
    </div>
  </div>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
